import type { JSX } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';
import { Loader } from '@change-corgi/design-system/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { PsfSharePagePrefetchedDataProps } from 'src/app/pages/psf/share/pageContext';
import { prefetchPageContext, PsfSharePageContextProvider } from 'src/app/pages/psf/share/pageContext';

import { Layout } from '../layout';

import { PsfShareErrorHandler } from './ErrorHandler';

export const PsfShare = withPrefetchedData(
	function PsfShare({ prefetchedData }: PsfSharePagePrefetchedDataProps): JSX.Element {
		const { slug } = useKnownAvailableParams<{ slug: string }>();

		return (
			<PsfSharePageContextProvider
				slug={slug}
				prefetchedData={prefetchedData}
				errorHandler={PsfShareErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</PsfSharePageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.slug!, context),
	},
);
